
import mapGetActions from '../common/client/sagas/map';

export const MAP_SET_TEMP_FEATURE = 'map/SET_TEMP_FEATURE';

export default function getActions(dispatch) {
    return {
        ...mapGetActions(dispatch),

        setTempFeature: (feature) => dispatch({
            type: MAP_SET_TEMP_FEATURE, feature
        })
    };
}
